<script>
import { iButton } from '@inscribe/signal';
import { InscribeEventsLogger } from '@/events-logger';

export default {
  components: { iButton },

  props: {
    bannerVisible: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      visible: false,
      COOKIE_NAME: 'cookieconsent_status',
      COOKIE_VALUE_ALLOW: 'allow',
      COOKIE_VALUE_DENY: 'deny',
      COOKIE_VALUE_DISMISS: 'dismiss',
    };
  },

  watch: {
    bannerVisible: function (newVal, oldVal) {
      if (newVal.toString() === 'true') {
        this.visible = true;
      }
    },
  },

  mounted() {
    this.visible = this.bannerVisible;
    const cookieValue = this.getCookie(this.COOKIE_NAME);

    // banner is visible just if the user has not the cookie in the browser
    if (
      !cookieValue ||
      ![
        this.COOKIE_VALUE_ALLOW,
        this.COOKIE_VALUE_DENY,
        this.COOKIE_VALUE_DISMISS,
      ].includes(cookieValue)
    ) {
      this.visible = true;
    } else if (cookieValue === this.COOKIE_VALUE_ALLOW) {
      this.runCookieAcceptedCode();
    }
  },

  methods: {
    runCookieAcceptedCode() {
      InscribeEventsLogger.LOGGING_ENABLED = true;
      InscribeEventsLogger.init();
    },

    onCookieAccepted() {
      this.runCookieAcceptedCode();
      this.writeCookie(this.COOKIE_VALUE_ALLOW);
      this.closeBanner();
    },

    onCookieRejected() {
      this.writeCookie(this.COOKIE_VALUE_DENY);
      this.closeBanner();
    },

    closeBanner() {
      this.visible = false;
    },

    getCookie(cname) {
      const name = cname + '=';
      const decodedCookie = decodeURIComponent(document.cookie);
      const ca = decodedCookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    },

    writeCookie(value) {
      const expiryDate = new Date();
      expiryDate.setTime(expiryDate.getTime() + 365 * 24 * 60 * 60 * 1000);
      document.cookie = `${this.COOKIE_NAME}=${value};path=/;domain=${
        window.location.hostname
      };expires="${expiryDate.toUTCString()}`;
    },
  },
};
</script>

<template>
  <div
    v-if="visible"
    class="cookie-consent d-flex justify-content-space-between"
  >
    <div class="text d-flex flex-column i-text-body-2 i-text-neutral-110">
      <div>This website uses cookies to improve your experience.</div>
      <a
        aria-label="learn more about cookies"
        data-dd-action-name="cookie-consent-privacy-link"
        class="cc-link"
        href="https://www.inscribe.ai/privacy"
        rel="noopener noreferrer nofollow"
        target="_blank"
        >View our Privacy Policy</a
      >
    </div>
    <div class="buttons d-flex i-gap-4">
      <i-button
        text="Decline Optional"
        type="neutral"
        subtype="subtle"
        data-testid="cookies-decline-button"
        @button-click="onCookieRejected"
      >
      </i-button>
      <i-button
        text="Allow All Cookies"
        @button-click="onCookieAccepted"
      ></i-button>
    </div>
  </div>
</template>

<style scoped>
.cookie-consent {
  position: fixed;
  background: white;
  left: 20%;
  right: 20%;
  bottom: 40px;
  width: 60%;
  max-width: 1000px;
  z-index: 10000;
  padding: 16px 16px 16px 24px;
  margin: 16px 32px;
  border: 1px solid #ddd8e7;
  color: #65636d;
  border-radius: 20px;
  box-shadow:
    0 6px 12px #0000000d,
    0 22px 22px #0000000a,
    0 50px 30px #00000008,
    0 89px 36px #00000003,
    0 139px 39px #0000;
}
</style>
